import React from 'react'


class AboutPerson extends React.Component {

  //Props name, title, description, linkedin, mail, website

  renderButtons() {

    const linkedInButton = (
      <li>
        <a className='linkend-in-button' href={this.props.linkendin}><div></div></a>
      </li>
    )

    const mailButton = (
      <li>
        <a href={this.props.mail} className='email-button'><div></div></a>
      </li>
    )

    const websiteButton = (
      <li>
        <a href={this.props.website} className='website-button'><div></div></a>
      </li>
    )

    return(
      <ul className='button-list'>
        {this.props.linkendin && linkedInButton}
        {this.props.mail && mailButton}
        {this.props.website && websiteButton}
      </ul>
    )
  }

  render() {
    return (
      <div className='about-person'>
        <div className={`${this.props.image} about-us-image`}></div>
        <h3 className='about-name'>
          {this.props.name}
        </h3>
        <h4>
          {this.props.title}
        </h4>
        <p className='about-description'>
          {this.props.description}
        </p>
        {this.renderButtons()}
      </div>
    )
  }
}

export default AboutPerson
